import { BaseModule } from '@/HostApp/store/ApsModules/BaseModule';

/**
 * This module will be attached to each legacy iframe aps.apsc variable, to get an opportunity manage iframe state
 **/

export default class IframeApscModule extends BaseModule {
	constructor() {
		super();
		this.createProxyHandler(this, 'showPopup', this.showPopup);
	}

	public showPopup = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			return Reflect.apply(target, thisArg, args);
		}
	};
}
